const getArrayPage = (sourceArray, pageNumber, pageSize) => {
  const startIndexInclusive = (pageNumber - 1) * pageSize
  const endIndexNonInclusive = pageNumber * pageSize

  return sourceArray.slice(startIndexInclusive, endIndexNonInclusive)
}

const getBasicSortFunction = (options) => options.direction === 'asc'
  ? (left, right) => {
    if (left[options.field] > right[options.field]) return 1
    if (left[options.field] < right[options.field]) return -1
    return 0
  }
  : (left, right) => {
    if (left[options.field] < right[options.field]) return 1
    if (left[options.field] > right[options.field]) return -1
    return 0
  }

const arraysIntersect = (firstArray, secondArray) => firstArray
  .some((firstElement) => secondArray.some((secondElement) => secondElement === firstElement))

const errorMessages = {
  ARRAY_REQUIRED: 'expected array',
  INTEGER_REQUIRED: 'expected integer'
}

const chunkArray = (array, size) => {
  if (!Array.isArray(array)) throw new Error(errorMessages.ARRAY_REQUIRED)
  if (!Number.isInteger(size)) throw new Error(errorMessages.INTEGER_REQUIRED)

  const result = []
  for (let i = 0; i < array.length; i += size) {
    result.push(array.slice(i, i + size))
  }

  return result
}

module.exports = {
  arraysIntersect,
  getArrayPage,
  getBasicSortFunction,
  chunkArray
}
